
$(function() {

	$('.ot-button').click(function (e) {
		e.preventDefault();
		$('.ot-info').slideToggle(900);
	});

	$(window).on('wheel touchmove', function () {
		$('.ot-info').slideUp(900);
	});

	$('.ot-form').on('submit', function (e) {
		e.preventDefault();

		if(typeof ga !== 'undefined') {
			ga('send', 'event', 'reservation', 'click', 'Find a Table');
		}
    });

});










